// Файл index.js

/**
 * Модуль «index» содержит логику, относящуюся к разделу «Driver Panel».
 * Он объединяет связанные обработчики, данные или элементы интерфейса и предоставляет их соседним модулям приложения.
 * Такое разделение упрощает сопровождение, тестирование и повторное использование этой части кода.
 */

import { createPortal } from 'react-dom';

import './DriverPanel.css';



const DriverPanel = ({
    isOpen,
    title,
    onClose,
    width,
    children,
    scrollable = true,
    className = '',
    overlayClassName = '',
    header_actions = null,
    style = null,
}) => {
    const panelStyle = {
        ...(width ? { width } : {}),
        ...(style || {}),
    };
    const bodyClassName = `drawer-body ${
        scrollable ? 'drawer-body--scrollable' : 'drawer-body--fixed'
    }`;

    return createPortal(
        <>
            {isOpen && (
                <div
                    className={`drawer-overlay ${overlayClassName}`.trim()}
                    onClick={onClose}
                />
            )}

            <div
                className={`drawer-panel ${isOpen ? 'open' : ''} ${className}`.trim()}
                style={panelStyle}
            >
                <div className="drawer-header">
                    <div className="drawer-header__main">
                        <span className="drawer-title">
                            {title}
                        </span>

                        {header_actions && (
                            <div className="drawer-header__actions flex-align-center">
                                {header_actions}
                            </div>
                        )}
                    </div>

                    <button
                        className="drawer-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <div className={bodyClassName}>
                    {children}
                </div>
            </div>
        </>,
        document.body
    );
};


export default DriverPanel;